import { render, staticRenderFns } from "./confirmDeletionFormModal.vue?vue&type=template&id=10d73c58&"
import script from "./confirmDeletionFormModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports